module.exports = __webpack_public_path__ + "static/media/check-o.6f686e92.svg";